import { query, collection } from "@firebase/firestore";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { db } from "../firebase";
import { contactListConverter } from "../firebase/firestore/contacts";

export default function useUserLists(creatorId: string) {
  return useCollectionData(
    query(collection(db, "users", creatorId, "contact_lists")).withConverter(contactListConverter)
  );
}
